<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">

        <div class="columns">
            <div class="column is-12">
                <div class="card is-hidden1">
                    <div class="card-header" style="padding: 10px;">
                        Awarded Behaviors &amp; Points by {{ teacherName }}
                        <b-select id="duration" name="duration" v-model="duration" size="is-small" style="margin-left: 10px;" @input="getSubmissions()">
                            <option :value="nextYear">{{ nextYear }}</option>
                            <option :value="currentYear">{{ currentYear }}</option>
                            <option value="1">January</option>
                            <option value="2">February</option>
                            <option value="3">March</option>
                            <option value="4">April</option>
                            <option value="5">May</option>
                            <option value="6">June</option>
                            <option value="7">July</option>
                            <option value="8">August</option>
                            <option value="9">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                            <option value="13">Ramadhan 2020</option>
                            <option value="2019">2019</option>
                        </b-select>
                        <b-select id="sortBy" name="sortBy" v-model="sortBy" size="is-small" style="margin-left: 10px;" @input="sortSubmissions()">
                            <option value="0">By Dates</option>
                            <option value="1">By Points</option>
                            <option value="2">By Names</option>
                        </b-select>
                        <a class="button is-info is-small" style="position: absolute; right: 10px;" v-on:click="getSubmissions('excel')">Download As Excel</a>
                    </div>
                    <div class="card-content">
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        <div class="columns bottom-border" style="margin-top: 10px;">
                            <div class="column is-1">#</div>
                            <div class="column">Behavior</div>
                            <div class="column" style="text-align: center;">Points<br/>(Scan count: {{ totalScans }})</div>
                            <div class="column" style="text-align: center;">Total Points<br>{{ roundTo2DecimalPlaces(totalPoints) }}</div>
                            <div class="column">Student &amp; Kelas</div>
                            <div class="column">Date</div>
                        </div>
                        <div class="columns top-border" v-for="(submittedBehavior,index) in sortSubmissions(submittedBehaviorList)" :key="submittedBehavior._id">
                            <div class="column is-1">{{ index + 1 }}</div>
                            <div class="column">{{ submittedBehavior.positiveID.name }}</div>
                            <div class="column" style="text-align: center;">{{ submittedBehavior.points }} x {{ submittedBehavior.multiply }}</div>
                            <div class="column" style="text-align: center;">{{ roundTo2DecimalPlaces(submittedBehavior.totalPoints) }}</div>
                            <div class="column">{{ submittedBehavior.studentID.firstName }} ({{ submittedBehavior.kelasID.level }} {{ submittedBehavior.kelasID.name }})</div>
                            <div class="column">{{ displayDate(submittedBehavior.actionDate) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "./public/style.scss";
const helper = require("../../config/helper")

export default {
    name: "TeacherActivitiesView",
    components: {
        NewTopMenu,
        Loading,
    },
    data() {
        return {
            teacherID: '',
            teacherName: '',
            sortBy: 0,
            totalPoints: 0,
            totalScans: 0,
            isLoading: false,
            submittedBehaviorList: [],
            currentYear: 0,
            currentMonth: 0,
            nextYear: 0
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    created() {
        var currentDate = new Date(); 
        this.currentYear = currentDate.getFullYear();
        this.currentMonth = currentDate.getMonth() + 1;  //since month starts from 0
        this.nextYear = this.currentYear + 1

        this.teacherID = this.$store.getters.getTeacherID;

        if (this.teacherID.trim.length < 1){
            this.teacherID = localStorage.getItem('TEACHER_ID')
        }

        this.teacherName = this.$store.getters.getTeacherName;

        if (this.teacherName.trim.length < 1){
            this.teacherName = localStorage.getItem('TEACHER_NAME')
        }

        this.duration = currentDate.getMonth() + 1; //just an init value

        this.duration = this.$store.getters.getDuration;

        if (this.duration < 1){
            this.duration = localStorage.getItem('DURATION')
        }
        console.log("133 teacherID: " + this.teacherID)
        console.log("133 teacherName: " + this.teacherName)
        console.log("133 duration: " + this.duration)

        this.getSubmissions()

    },
    mounted(){
    },
    methods: {
        getSubmissions(output){
            let self = this

            var durationDisplay = "";
            if (self.duration >= 2019){
                durationDisplay = self.duration
            }else if (self.duration == 13){
                durationDisplay = "Ramadhan 2020"
            }else{
                var displayMonth = helper.displayMonth(self.duration)
                durationDisplay = displayMonth
            }
            console.log("150 durationDisplay: " + durationDisplay)
            self.isLoading = true

            if (output == "excel"){
                axios.defaults.responseType = 'blob'
            }else{
                axios.defaults.responseType = 'json'
            }
            axios.post(process.env.MY_URL + '/teachersV2/activities/view', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                teacherID: self.teacherID,
                kelasID: self.kelasID,
                duration: self.duration,
                output: output
            })
            .then(response => {
                if (output == "excel"){
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', "Teacher Activities - " + this.teacherName + " - " + durationDisplay + ".xlsx");
                    document.body.appendChild(link);
                    link.click();
                }else{
                    self.submittedBehaviorList = response.data
                    self.totalPoints = 0
                    self.totalScans = 0
                    for (var i = 0; i < self.submittedBehaviorList.length; i++){
                        self.totalPoints = self.totalPoints + self.submittedBehaviorList[i].totalPoints
                        self.totalScans = self.totalScans + 1
                    }

                }
                self.isLoading = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })

        },
        displayDate(date){
            try{
                var getYear = date.substring(0,4);
                var getMonth = date.substring(4,6);
                var getDay = date.substring(6);

                return getDay + "/" + getMonth + "/" + getYear;
            }catch(err){
                console.log(err)
                return date;
            }
        },
        displayInfo(dataType,remarks,status){
            if (dataType == 2){
                if (status == 2){
                    return "Late"
                }else{
                    return "On-Time"
                }
            }else{
                return remarks
            }
        },
        roundTo2DecimalPlaces(points){  //use lodash to round the points to 2 decimal places
            return _.round(points, 2)
            // return _.round(points, 2).toFixed(2)
        },
        goActivitiesView(id,name){
            this.$store.commit('UPDATE_TEACHER_ID',id)
            this.$store.commit('UPDATE_TEACHER_NAME',name)
            this.$store.commit('UPDATE_DURATION_MONTH',this.duration)
            localStorage.setItem('TEACHER_ID',id)
            localStorage.setItem('TEACHER_NAME',name)
            localStorage.setItem('DURATION_MONTH',this.duration)
            this.$router.push({
                name: "TeacherActivitiesView"
            });
        },
        sortSubmissions(arrays){
            if (this.sortBy == 1){  //points
                return _.orderBy(arrays, 'totalPoints', 'desc');  //we're using the magical lodash function here
            }else if (this.sortBy == 2){  //names
                return _.orderBy(arrays, 'positiveID.name', 'asd');  //we're using the magical lodash function here
            }else{  //date
                return _.orderBy(arrays, 'actionDate', 'desc');  //we're using the magical lodash function here
            }            
        },
    },
};
</script>

<style scoped>
.bottom-border{
    border-bottom: 1px solid #CCC
}
.container{
    padding: 10px;
}
.text-center{
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/TeacherActivitiesView.vue